// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.confirm-terms-box {\n  width: 700px;\n  font-size: 16px;\n  font-family: Poppins, Poppins;\n  font-weight: 400;\n  color: #0E101A;\n  line-height: 25px;\n}\n/* .el-message-box__content {\n  height: 66px;\n} */\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
